<template>
  <div class="icon">
    <component :is="iconComponent" class="icon__svg" />
  </div>
</template>

<script>
const ICONS = {
  'arrows-down': () => import('../../assets/icons/arrows-down.svg?inline'),
  rotate: () => import('../../assets/icons/rotate.svg?inline'),
  swipe: () => import('../../assets/icons/swipe.svg?inline'),
  'rotate-phone': () => import('../../assets/icons/rotate-phone.svg?inline'),
};

export default {
  name: 'Icon',

  props: {
    icon: {
      type: String,
      required: true,
      validator: icon => Object.keys(ICONS).includes(icon),
    },
  },

  computed: {
    iconComponent() {
      return ICONS[this.icon];
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 220px;
}

$icon-size: 30px;
.icon__svg {
  width: $icon-size;
  height: $icon-size;
  margin-bottom: 10px;
}
</style>
